jQuery(($) => {

    if ($('.a-layered-animated-gifs')[0]){
        $('.a-layered-animated-gifs__tooltip-trigger').click(function () {
            $(this).closest('.a-layered-animated-gifs__item').toggleClass('a-layered-animated-gifs__item--active');
            $(this).closest('.a-layered-animated-gifs').toggleClass('a-layered-animated-gifs--playing');
        });
    } 
}); 